import { FormElement } from '../form-element.model';

export class FormElementEmailOptIn extends FormElement {
  Label: string;
  Message: string;
  public constructor() {
    super();
    this.Label = '';
    this.Message = '';
    this.ElementTypeId = 20;
  }
}
